<template>
<div class="container">
    <div class="alert alert-warning">
        {{$t("Le service offert sur cette page permet de créer et de gérer son compte Géoportail.")}}
    </div>
    <div class="alert alert-danger" v-if="isError">
        {{$t("Impossible de vous connecter. Veuillez vérifier votre identifiant et mot de passe.")}}
    </div>
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">Sign In</h5>
                <form class="form-signin" @submit.prevent="connect">
                    <div class="form-label-group">
                        <input type="text" id="username" name="username" v-model="username" class="form-control" v-bind:placeholder="$t('Utilisateur Geoportail')" required="" autofocus=""  autocomplete="username">
                        <label for="username">{{$t("Utilisateur Geoportail")}}</label>
                    </div>
                    <div class="form-label-group">
                        <input type="password" id="inputPassword" name="password" v-model="password" class="form-control" v-bind:placeholder="$t('Mot de passe')" required=""  autocomplete="current-password" > 
                        <label for="inputPassword">{{$t("Mot de passe")}}</label>
                    </div>
                    <button class="btn btn-lg btn-primary btn-block text-uppercase" type="submit">{{$t("Connexion")}}</button>
                    <p class="forgot-password text-right mt-2 mb-4">
                        <router-link to="/new-user">{{$t("Create user")}}</router-link> |
                        <router-link to="/recover-password">{{$t("Recover password")}}</router-link> |
                        <router-link to="/delete-account">{{$t("Delete account")}}</router-link>
                    </p>
                </form>
            </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import { ref } from 'vue';
export default {
    name: 'Login',
    setup(props, context) {
        const isError = ref(false);
        const username = ref('');
        const password = ref('');
        const connect = function() {
            let formData = new FormData();
            formData.append('username', this.username);
            formData.append('password', this.password);
            fetch("api/login", {
                body: formData,
                method: "post"
            }).then(function(resp) {
                resp.json().then(function(userSettings) {
                    if ('username' in userSettings) {
                        isError.value = false;
                        context.emit("connect", userSettings);
                    } else {
                        isError.value = true;
                    }
                }.bind(this));
            }.bind(this));
        }
        return {
            connect,
            username,
            password,
            isError
        }
    }
}

</script>
<style scoped>
</style>
